/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'CarouselBlog';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.slider = this.$el.slick({
            dots: false,
            mobileFirst: true,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            pauseOnHover: false,
            autoplaySpeed: 5000,
            arrows: false,
            fade: false,
            speed: 900
        });
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
